var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-wrap"},[_c('pre',{staticClass:"h2_title"},[_vm._v(_vm._s(_vm.c.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }